import queries from '@apis/queries';
import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import useModal from '@hooks/ui/useModal';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

function useNutritionModal(itemId: string) {
  const { openModal } = useModal();
  const { data } = useQuery({
    ...queries.items.nutrition(itemId),
    retry: 2,
  });
  const nutritionExists = useMemo(() => {
    if (data) {
      const keys = Object.keys(data);
      for (let i = 0; i < keys.length; i += 1) {
        // @ts-ignore
        if (data[keys[i]]) {
          return true;
        }
      }
    }
    return false;
  }, [data]);
  const openNutritionModal = () => {
    openModal(<Column fullWidth align='center' spacing={28}>
      <Column spacing={2} align='center'>
        <Text size='lg' fontWeight='bold'>제품영양정보</Text>
        {data?.servingSize && (
            <Text>({data?.servingSize} 기준)</Text>
        )}
      </Column>
      {(!nutritionExists) && (
          <Row fullWidth justify='center'>
            <Text color={colors.gray6}>영양정보가 존재하지 않습니다.</Text>
          </Row>
      )}
      <Column fullWidth spacing={16}>
        {data?.calories && (
            <Row fullWidth justify='space-between'>
              <Text size='lg'>칼로리</Text>
              <Text size='lg' fontWeight='bold'>{data?.calories}</Text>
            </Row>
        )}
        {data?.sodium && (
            <Row fullWidth justify='space-between'>
              <Text size='lg'>나트륨</Text>
              <Text size='lg' fontWeight='bold'>{data?.sodium}</Text>
            </Row>
        )}
        {data?.sugar && (
            <Row fullWidth justify='space-between'>
              <Text size='lg'>당류</Text>
              <Text size='lg' fontWeight='bold'>{data?.sugar}</Text>
            </Row>
        )}
        {data?.saturatedFat && (
            <Row fullWidth justify='space-between'>
              <Text size='lg'>포화지방</Text>
              <Text size='lg' fontWeight='bold'>{data?.saturatedFat}</Text>
            </Row>
        )}
        {data?.protein && (
            <Row fullWidth justify='space-between'>
              <Text size='lg'>단백질</Text>
              <Text size='lg' fontWeight='bold'>{data?.protein}</Text>
            </Row>
        )}
        {data?.caffeine && (
            <Row fullWidth justify='space-between'>
              <Text size='lg'>카페인</Text>
              <Text size='lg' fontWeight='bold'>{data?.caffeine}</Text>
            </Row>
        )}
        {data?.allergyComment && (
            <Row fullWidth justify='space-between'>
              <Text size='lg'>알러지 정보</Text>
              <Text size='lg' fontWeight='bold'>{data?.allergyComment}</Text>
            </Row>
        )}

        {data?.carbohydrate && (
            <Row fullWidth justify='space-between'>
              <Text size='lg'>탄수화물</Text>
              <Text size='lg' fontWeight='bold'>{data?.carbohydrate}</Text>
            </Row>
        )}
        {data?.fat && (
            <Row fullWidth justify='space-between'>
              <Text size='lg'>지방</Text>
              <Text size='lg' fontWeight='bold'>{data?.fat}</Text>
            </Row>
        )}
        {data?.cholesterol && (
            <Row fullWidth justify='space-between'>
              <Text size='lg'>콜레스트롤</Text>
              <Text size='lg' fontWeight='bold'>{data?.cholesterol}</Text>
            </Row>
        )}
        {data?.transFat && (
            <Row fullWidth justify='space-between'>
              <Text size='lg'>트랜스 지방</Text>
              <Text size='lg' fontWeight='bold'>{data?.transFat}</Text>
            </Row>
        )}
        {data?.origin && (
            <Row fullWidth justify='space-between'>
              <Text size='lg'>원산지</Text>
              <Text size='lg' fontWeight='bold'>{data?.origin}</Text>
            </Row>
        )}
      </Column>
    </Column>, true);
  };
  return { openNutritionModal, nutritionExists };
}

export default useNutritionModal;
